import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { CheckListItem } from '../types';
import { apiFetch } from '@/core';
import env from '@/env';

export const updateAuditorVisitCheckListItemById = async ({
  checkListItemId,
  data,
}: {
  checkListItemId: string;
  data: { confDat: string };
}): Promise<CheckListItem> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-visits/check-list-items/${checkListItemId}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as CheckListItem;
  return response;
};
